export default __webpack_public_path__ + "static/media/error.0b641e3b.gif";